import { useMemo } from 'react';
export var useCreateDocumentActions = function (isActionMenuRenderingPhase, item, createDocumentActionsOptions) {
    return useMemo(function () {
        if (isActionMenuRenderingPhase &&
            createDocumentActionsOptions &&
            createDocumentActionsOptions.createDocumentActions) {
            var index = createDocumentActionsOptions.index, itemElementId = createDocumentActionsOptions.itemElementId;
            return createDocumentActionsOptions.createDocumentActions(item, index, itemElementId);
        }
        return {
            actionMenuItems: [],
            commandItems: [],
        };
    }, [
        isActionMenuRenderingPhase,
        item,
        createDocumentActionsOptions,
        createDocumentActionsOptions === null || createDocumentActionsOptions === void 0 ? void 0 : createDocumentActionsOptions.createDocumentActions,
    ]);
};
//# sourceMappingURL=useCreateDocumentActions.js.map